import type { ResponseWithType, GallerySample, PhotosResponse } from './types';

const gallerySampleResponse = ({ data }: ResponseWithType<PhotosResponse>): GallerySample => {
  return {
    __typename: 'GallerySample',
    photos: data.photos.map((photo) => ({
      ...photo,
      photosAppPath: `/groups/${photo.group}/photos/${photo.id}`,
      __typename: 'Photo',
    })),
  };
};

export default gallerySampleResponse;
